import React from 'react';
import './Beteckning.css';
import { setInputFields } from '../utils/FsokUtils';
import { Checkbox } from '@mui/material';

interface BeteckningProps {
  beteckning: string;
  markerad: boolean;
  taBort: (beteckning: string) => void;
  klicka: (beteckning: string) => void;
  hovra: (beteckning: string) => void;
  markera: (beteckning: string) => void;
  objektId: string;
}

const Beteckning = (props: BeteckningProps) => {
  const setActive = () => {
    const b = document.getElementsByClassName(
      'beteckning-container'
    ) as HTMLCollectionOf<HTMLElement>;
    if (b !== null) {
      for (let i = 0; i < b.length; i++) {
        const second = document.getElementsByClassName('beteckning-container')[
          i
        ] as HTMLElement;
        second.style.backgroundColor = '#fff';
      }
    }
  };

  const handleCheckBox = () => {
    props.markera(props.beteckning);
  };

  return (
    <div
      className="beteckning-container"
      id={props.objektId}
      tabIndex={0}
      onClick={setActive}
    >
      <div
        className="list-checkbox"
        onMouseEnter={() => props.hovra(props.beteckning)}
        onMouseLeave={() => props.hovra('')}
        onClick={() => {
          props.klicka(props.beteckning);
          setInputFields(props.beteckning);
        }}
      >
        <Checkbox
          checked={props.markerad}
          size="small"
          inputProps={{ 'aria-label': 'checkbox with default color' }}
          onClick={handleCheckBox}
        />
      </div>
      <div
        className="beteckning"
        onMouseEnter={() => props.hovra(props.beteckning)}
        onMouseLeave={() => props.hovra('')}
        onClick={() => {
          props.klicka(props.beteckning);
          setInputFields(props.beteckning);
        }}
      >
        {props.beteckning}
      </div>
      <div
        className="cross-wrapper"
        onMouseEnter={() => props.hovra(props.beteckning)}
        onClick={() => props.taBort(props.beteckning)}
      >
        <span className="cross">x</span>
      </div>
    </div>
  );
};

export default Beteckning;
